// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__b1cyt","input":"Input_input__5nkAI"};